"use client";

import React from "react";
import { motion } from "framer-motion";
import { Building2, Utensils, ChefHat, ShoppingCart, Store, Factory, Wheat, Hospital } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const sectors = [{
  name: "Hotel",
  icon: Building2
}, {
  name: "Ristoranti",
  icon: Utensils
}, {
  name: "Mense",
  icon: ChefHat
}, {
  name: "Supermercati",
  icon: ShoppingCart
}, {
  name: "Gastronomie",
  icon: Store
}, {
  name: "Cucine centralizzate",
  icon: Factory
}, {
  name: "Industrie alimentari",
  icon: Wheat
}, {
  name: "Strutture sanitarie e RSA",
  icon: Hospital
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export default function SettoriServiti() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="settoriserviti" className="bg-secondary py-24 overflow-hidden border-b-0">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: -20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="mb-16 text-center">
          <h2 className="font-default text-5xl font-bold tracking-tight text-white sm:text-6xl">
            Settori serviti
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" animate={isVisible ? "show" : "hidden"} className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {sectors.map((sector, index) => {
          const Icon = sector.icon;
          return <motion.div key={sector.name} data-index={index} variants={itemVariants} className="group relative flex flex-col items-center justify-center rounded-md border border-primary/50 bg-transparent p-8 text-center transition-colors duration-300 hover:bg-primary">
                <div className="mb-4 relative">
                  <Icon className="h-10 w-10 text-accent transition-all duration-300 group-hover:scale-110" strokeWidth={1.5} />
                  {}
                  <div className="absolute inset-0 rounded-lg bg-accent opacity-0 blur-md transition-opacity duration-300 group-hover:animate-pulse group-hover:opacity-40" />
                </div>
                <h3 className="font-sans text-lg font-medium text-white">
                  {sector.name}
                </h3>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}